import ApiClient from '@/api/ApiClient';

const client = new ApiClient('tempworker/usernews');

class UserNewsApiTempWorker {

	static countNotRead () {
		return client.get<number>('countNotRead');
	}

	static grid (filters: OmitUserId<IUserNewsPagedListParameters>) {
		return client.post<IPagedList<IUserNewsModel>>('grid', filters);
	}

	static read (ids: number[]) {
		return client.put<void>('read', ids);
	}

}

export default UserNewsApiTempWorker;
